import { combineReducers } from 'redux';
import job from './job.reducer';

const reducer = combineReducers({
	job
});

export default reducer;
